export default __webpack_public_path__ + "static/media/ethers.dbc2c675.png";